import { CSSObject } from "@emotion/react";
import { cssVariableStyles, constants } from "@newsela/angelou";
const { generateIconColorCss } = cssVariableStyles;

const { ui } = constants.colors;
const coreBlue500 = ui.core[500];

export const containerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
  alignItems: "center",
  gap: "8px",
  width: "100%",
  fontSize: "14px",
};

export const blueIconCss: CSSObject = {
  height: "24px",
  width: "24px",
  ...generateIconColorCss({ primaryColor: coreBlue500 }),
};

export const trendLoadingSpinnerCss: CSSObject = {
  ...blueIconCss,
  margin: "0px",
};
